import React, {useState} from 'react';
import {bool, object, func} from 'prop-types';

import {connect} from 'react-redux';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './TableRowMenu.module.css';

const EquipmentTableRowMenu = ({
    equipment,
    filterBy,
    hidden,
    onToggleDeleteEquipmentEntityModal,
    setEquipment,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    if (hidden) {
        return null;
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
        setEquipment(equipment);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleRemoveAssociation() {
        onToggleDeleteEquipmentEntityModal(true);

        handleClose();
    }

    function handleRemoveEquipment() {
        onToggleDeleteEquipmentEntityModal(true);

        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                {
                    filterBy === 'system' &&
                    <MenuItem onClick={handleRemoveAssociation}>
                        <img
                            alt=""
                            className={classes.contextIcon}
                            src="/assets/images/deleteIconColor.svg"
                        />
                        Remove System Association
                    </MenuItem>
                }
                {
                    filterBy === 'areaItem' &&
                    <MenuItem onClick={handleRemoveEquipment}>
                        <img
                            alt=""
                            className={classes.contextIcon}
                            src="/assets/images/SettingsFlat.svg"
                        />
                        Remove Equipment from Area
                    </MenuItem>
                }
            </Menu>
        </React.Fragment>
    );
};

EquipmentTableRowMenu.defaultProps = {
    hidden: false
};

EquipmentTableRowMenu.propTypes = {
    equipment:    object,
    hidden:       bool,
    setEquipment: func
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default connect(null, mapDispatchToProps)(EquipmentTableRowMenu);
